import React from "react";
import { Dialog, DialogContent, Box, Button, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

// Pre-apply eligibility/duplicate-application guard (Class G,
// regression/plan/05-PLAN.md Phase 5), ported from dfs-mobile-app's
// SchemeApplyEligibilityDialog — server's own localized `message`, single
// Close button, no override CTA. Shared by CITIZEN (schemeApplyGate.js) and
// AGENT (FarmerContextRoute's SCHEME_APPLY_PROFILE_GET OTP response).
export const RewampApplyEligibilityDialog = ({ open, onClose, reason }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="rewamp-apply-eligibility-desc"
      PaperProps={{
        sx: {
          width: "492px",
          maxWidth: "calc(100% - 32px)",
          borderRadius: "16px",
          border: "1.5px solid",
          borderColor: "divider",
          boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.04)",
          p: 4,
        },
      }}
    >
      <DialogContent
        sx={{
          p: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 3,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
          <InfoOutlinedIcon aria-hidden="true" sx={{ fontSize: 24, color: "text.textGrey" }} />
          <Typography
            id="rewamp-apply-eligibility-desc"
            variant="h5"
            component="p"
            sx={{ color: "text.textGrey", textAlign: "center" }}
          >
            {reason || t("schemes.applyEligibilityFallbackMessage")}
          </Typography>
        </Box>
        <Button variant="primary" size="cardAction" onClick={onClose} autoFocus>
          {t("schemes.close")}
        </Button>
      </DialogContent>
    </Dialog>
  );
};

RewampApplyEligibilityDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  /** Server's localized `message[lang]` for the current session's language. */
  reason: PropTypes.string,
};

export default RewampApplyEligibilityDialog;
